module.exports = __webpack_public_path__ + "static/media/shareride.e21f21d7.png";